import { render, staticRenderFns } from "./CommunityDetailTwo.vue?vue&type=template&id=0e3e758e&scoped=true&"
import script from "./CommunityDetailTwo.vue?vue&type=script&lang=js&"
export * from "./CommunityDetailTwo.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDetailTwo.vue?vue&type=style&index=0&id=0e3e758e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e758e",
  null
  
)

export default component.exports